// extracted by mini-css-extract-plugin
export default {"openTag":"openLaunchApp_openTag__mWbCw"};